import App from './App'
import router from '@v2/router'
import Vue from 'vue'
import es6Promise from 'es6-promise'
import './config/global'
import '@v2/static/js/globalProto'
import '@v2/static/js/component'
import '@v2/static/js/directive'

es6Promise.polyfill()
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  data: {
    birthday: '2017-08-24'
  },
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/v2/main.js